// Define constants (consider moving credentials to env vars later)

import fetchProxy from './fetchProxy'
import idParadaData from '../constants/id_parada.json'

const SOAP_URL = 'https://clswbsas.smartmovepro.net/moduloparadas/swparadas.asmx'
const USUARIO = 'WEB.MUNICESCOBAR'
const CLAVE = 'PAR.SW.ESCOBAR'
// const CODIGO_CUANDO_LLEGA = 32
const CODIGO_TIPO_APLICACION = 24
const IS_SUBLINEA = false
const LOCALIDAD = 'Escobar' // Proper locality description

/**
 * Converts XML string to JSON object
 * @param {string} xmlString - The XML string to parse
 * @returns {Object} The parsed JSON object
 */
function xmlToJson(xmlString) {
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(xmlString, 'text/xml')

  // Extract the result from the SOAP response
  const resultElement = xmlDoc.querySelector('RecuperarProximosArribosResult')
  if (!resultElement) {
    throw new Error('No RecuperarProximosArribosResult found in response')
  }

  const resultText = resultElement.textContent
  if (!resultText) {
    return {}
  }

  try {
    // Try to parse as JSON first
    return JSON.parse(resultText)
  } catch (error) {
    // If it's not JSON, return the raw text
    return { rawResult: resultText }
  }
}

/**
 * Creates the SOAP envelope XML for the RecuperarProximosArribos request
 * @param {string} identificadorParada - The stop identifier
 * @param {number} codigoLineaParada - The line code (default to 0 to get all lines)
 * @returns {string} The SOAP envelope XML
 */
function createSoapEnvelope(identificadorParada, codigoLineaParada = 0) {
  return `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <RecuperarProximosArribos xmlns="http://clsw.smartmovepro.net/">
      <usuario>${USUARIO}</usuario>
      <clave>${CLAVE}</clave>
      <identificadorParada>${identificadorParada}</identificadorParada>
      <codigoLineaParada>${codigoLineaParada}</codigoLineaParada>
      <codigoAplicacion>${CODIGO_TIPO_APLICACION}</codigoAplicacion>
      <localidad>${LOCALIDAD}</localidad>
      <isSublinea>${IS_SUBLINEA}</isSublinea>
      <isSoloAdaptados>false</isSoloAdaptados>
    </RecuperarProximosArribos>
  </soap:Body>
</soap:Envelope>`
}

/**
 * Fetches real-time arrivals for a specific bus stop from MiBus SOAP API.
 * @param {string|number} stopId - The ID of the bus stop to get arrivals for
 * @returns {Promise<Object|undefined>} The arrivals data or undefined if an error occurs
 */
export const getRealTimeArrivalsMiBus = async (stopId) => {
  const stopIdWithoutEscobar = stopId.replace('escobar_', '')

  try {
    // Find the matching parada_id from the id_parada.json data
    const paradaId = idParadaData.find(item => item.id.toString() === stopIdWithoutEscobar.toString())
    if (!paradaId) {
      throw new Error(`No matching parada_id found for stopId: ${stopIdWithoutEscobar}`)
    }
    const arrivals = {
      arribos: []
    }

    for (const stop of paradaId.stops) {
      // console.log(`Parada ${stop}`)
      // Create the SOAP envelope with codigoLineaParada = 0 to get all lines for the stop
      const soapEnvelope = createSoapEnvelope(stop.toString(), 0)

      const response = await fetchProxy({
        url: SOAP_URL,
        method: 'POST',
        headers: {
          'Content-Type': 'text/xml; charset=utf-8',
          SOAPAction: 'http://clsw.smartmovepro.net/RecuperarProximosArribos'
        },
        body: soapEnvelope
      })

      // Parse the XML response to JSON
      const jsonResult = xmlToJson(response.result)
      // console.log('MiBus SOAP Response:', jsonResult)
      arrivals.arribos = arrivals.arribos.concat(jsonResult.arribos)
    }

    // console.log('MiBus Total Arrivals:', arrivals)
    return arrivals
  } catch (error) {
    console.error('Error fetching MiBus arrivals:', error.message)
    return undefined
  }
}
